import { NpsSurveyQuestionDto } from './nps-survey-question.dto';
import { NpsDto } from './nps.dto';

export class NpsSurveyDto {
  id?: number;
  pieMerchantGroupId: number;
  name: string;
  description: string;
  startDate?: Date;
  endDate?: Date;
  isActive?: boolean;
  isOnline?: boolean;
  isPublished?: boolean;
  createdDate?: Date;
  modifiedDate?: Date;
  questions?: NpsSurveyQuestionDto[];
  nps?: NpsDto;
}
